import React from 'react';
const rows = [{
  sit: 'Reclamo ante la ART',
  no: 'Firmás lo que te dan y perdés derechos',
  yes: 'Impugnás el alta en 1 hora con la carta del T2'
}, {
  sit: 'Conflicto laboral',
  no: 'Aceptás la liquidación sin verificarla',
  yes: 'Calculás lo que te corresponde y reclamás la diferencia'
}, {
  sit: 'Problema con el alquiler',
  no: 'Pagás aumentos ilegales por miedo',
  yes: 'Mandás la carta del T4 y el propietario se arregla'
}, {
  sit: 'Cobertura negada',
  no: 'Pagás el medicamento de tu bolsillo',
  yes: 'Reclamás ante la SSS y lo conseguís cubierto'
}, {
  sit: 'Cobro indebido bancario',
  no: 'Seguís pagando comisiones ilegales',
  yes: 'Reclamás ante el BCRA y te devuelven lo cobrado'
}, {
  sit: 'Buscar información',
  no: 'Horas en Google sin encontrar nada aplicable',
  yes: '45 minutos y sabés exactamente qué hacer'
}, {
  sit: 'Consulta de abogado',
  no: '$15.000 la consulta + honorarios por éxito',
  yes: 'Resolvés solo en la mayoría de los casos'
}];
export function VsTable() {
  return <section className="py-12 md:py-[70px] px-5 bg-white" data-id="element-334">
      <div className="max-w-[860px] mx-auto" data-id="element-335">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-blue mb-2" data-id="element-336">
          La realidad
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-navy mb-2 leading-tight" data-id="element-337">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
        <p className="text-[15px] md:text-[16px] text-text-muted max-w-[560px] mb-6 md:mb-9" data-id="element-338">
          El costo de no saber tus derechos se mide en plata, tiempo y reclamos
          perdidos.
        </p>

        {/* Mobile: Stacked Cards */}
        <div className="md:hidden space-y-3" data-id="element-339">
          {rows.map((row, i) => <div key={i} className="bg-off-white border border-border rounded-xl overflow-hidden" data-id="element-340">
              <div className="bg-sky px-4 py-2.5 border-b border-border" data-id="element-341">
                <h4 className="text-[13px] font-bold text-navy" data-id="element-342">{row.sit}</h4>
              </div>
              <div className="grid grid-cols-2 gap-0" data-id="element-343">
                <div className="p-3 border-r border-border" data-id="element-344">
                  <div className="text-[11px] font-bold text-danger mb-1.5" data-id="element-345">
                    ❌ Sin DEFENDETE
                  </div>
                  <p className="text-[11px] text-text-muted leading-snug" data-id="element-346">
                    {row.no}
                  </p>
                </div>
                <div className="p-3" data-id="element-347">
                  <div className="text-[11px] font-bold text-success mb-1.5" data-id="element-348">
                    ✅ Con DEFENDETE
                  </div>
                  <p className="text-[11px] text-text-muted leading-snug" data-id="element-349">
                    {row.yes}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Desktop: Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-350">
          <table className="w-full border-collapse text-[14px] min-w-[600px]" data-id="element-351">
            <thead data-id="element-352">
              <tr data-id="element-353">
                <th className="p-3.5 px-5 text-left text-[13px] font-bold bg-off-white text-text-muted rounded-tl-lg" data-id="element-354">
                  Situación
                </th>
                <th className="p-3.5 px-5 text-center text-[13px] font-bold bg-danger text-white" data-id="element-355">
                  ❌ Sin DEFENDETE
                </th>
                <th className="p-3.5 px-5 text-center text-[13px] font-bold bg-blue text-white rounded-tr-lg" data-id="element-356">
                  ✅ Con DEFENDETE
                </th>
              </tr>
            </thead>
            <tbody data-id="element-357">
              {rows.map((row, i) => <tr key={i} className="even:bg-off-white" data-id="element-358">
                  <td className="p-3 px-5 border-b border-border text-text-muted text-[13px]" data-id="element-359">
                    {row.sit}
                  </td>
                  <td className="p-3 px-5 border-b border-border text-center text-danger font-semibold" data-id="element-360">
                    {row.no}
                  </td>
                  <td className="p-3 px-5 border-b border-border text-center text-success font-semibold" data-id="element-361">
                    {row.yes}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}